import { Pipe, PipeTransform } from '@angular/core';

/*
 * Removes Transform a CPF in Hidden 6 Digits
 * Usage:
 *   value : value to transform
*/
@Pipe({ name: 'hiddenCPFPipe' })
export class HiddenCPFPipe implements PipeTransform {
  public transform(value: string): string {
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.***.***-$4");
  }
}